module.exports = __webpack_public_path__ + "img/diesel-locomotive-mask-07.b9b487b4.png";